const DATE_INPUT_SELECTOR = '.product-details .gpo-input-wrap .gpo-input';
const SELECTED_CLASS = 'mc-date-selected';
const QUANTITY_INPUT_SELECTOR = '.product-details .quantity-selector-wrapper input[type="number"]';
const QUANTITY_SELECTED_CLASS = 'mc-quantity-selected';

function extractNights(text) {
  const match = text?.match(/(\d+)\s*nuits?\b/i);
  return match ? Number(match[1]) : null;
}

function extractNightsFromOption(option) {
  if (!option) return null;

  const candidates = [
    ...option.querySelectorAll('[class*="help"], [class*="description"], [class*="desc"]'),
    option,
  ];

  for (const candidate of candidates) {
    const nights = extractNights(candidate.textContent || '');
    if (Number.isFinite(nights) && nights > 0) return nights;
  }

  return null;
}

function isOptionVisible(option) {
  return !option.hidden && option.getAttribute('aria-hidden') !== 'true' && option.getClientRects().length > 0;
}

function getAccommodationNights() {
  const selected = document.querySelector(
    '.product-details .gpo-swatches.image-swatches.gpo-ov-item input[type="radio"]:checked'
  );

  if (selected) {
    const card = selected.closest('.gpo-swatches.image-swatches.gpo-ov-item');
    const selectedNights = extractNights(card?.textContent || '') || extractNightsFromOption(card?.closest('.gpo-element'));
    if (selectedNights) return selectedNights;
  }

  const visibleOptions = document.querySelectorAll('.product-details .gpo-element');
  for (const option of visibleOptions) {
    if (!isOptionVisible(option) || !option.querySelector('.gpo-swatches.image-swatches.gpo-ov-item')) continue;
    const nights = extractNightsFromOption(option);
    if (nights) return nights;
  }

  return null;
}

function parseStartDate(value) {
  const parts = value.trim().match(/^(\d{1,4})[\/.-](\d{1,2})[\/.-](\d{1,4})$/);
  if (!parts) return null;

  const yearFirst = parts[1].length === 4;
  const year = Number(yearFirst ? parts[1] : parts[3]);
  const month = Number(parts[2]);
  const day = Number(yearFirst ? parts[3] : parts[1]);
  const date = new Date(year, month - 1, day);

  if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) return null;
  return date;
}

function syncEndDate(input, wrapper) {
  wrapper.parentElement?.querySelector(':scope > .mc-end-date')?.remove();
  const startDate = parseStartDate(input.value);
  const accommodationNights = getAccommodationNights();

  if (!startDate || !Number.isFinite(accommodationNights) || accommodationNights < 1) {
    if (wrapper.hasAttribute('data-mc-end-date')) wrapper.removeAttribute('data-mc-end-date');
    return;
  }

  const endDate = new Date(startDate);
  endDate.setDate(endDate.getDate() + accommodationNights);
  const formattedEndDate = new Intl.DateTimeFormat('fr-FR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  }).format(endDate);

  if (wrapper.dataset.mcEndDate !== formattedEndDate) wrapper.dataset.mcEndDate = formattedEndDate;
}

function syncGloboDateSelection() {
  document.querySelectorAll(DATE_INPUT_SELECTOR).forEach((input) => {
    const wrapper = input.closest('.gpo-input-wrap');
    if (!wrapper) return;

    wrapper.classList.toggle(SELECTED_CLASS, input.value.trim() !== '');
    syncEndDate(input, wrapper);

    if (!input.dataset.mcDateSelectionBound) {
      input.dataset.mcDateSelectionBound = 'true';
      input.addEventListener('input', () => {
        syncGloboDateSelection();
        setTimeout(syncGloboDateSelection, 150);
        setTimeout(syncGloboDateSelection, 500);
        setTimeout(syncGloboDateSelection, 1200);
      });
      input.addEventListener('change', () => {
        syncGloboDateSelection();
        setTimeout(syncGloboDateSelection, 150);
        setTimeout(syncGloboDateSelection, 500);
        setTimeout(syncGloboDateSelection, 1200);
      });
    }
  });
}

function syncQuantitySelection() {
  document.querySelectorAll(QUANTITY_INPUT_SELECTOR).forEach((input) => {
    const wrapper = input.closest('.quantity-selector-wrapper');
    if (!wrapper) return;

    wrapper.classList.toggle(QUANTITY_SELECTED_CLASS, Number(input.value) > 0);
    syncParticipantLimit(input, wrapper);

    if (!input.dataset.mcQuantitySelectionBound) {
      input.dataset.mcQuantitySelectionBound = 'true';
      input.addEventListener('input', syncQuantitySelection);
      input.addEventListener('change', syncQuantitySelection);

      wrapper.querySelectorAll('button').forEach((button) => {
        button.addEventListener('click', () => requestAnimationFrame(syncQuantitySelection));
      });
    }
  });
}

function syncParticipantLimit(input, wrapper) {
  const details = input.closest('.product-details');
  if (!details) return;
  let message = details.querySelector('.mc-participant-limit');
  if (!message) {
    message = document.createElement('p');
    message.className = 'mc-participant-limit';
    message.id = 'mc-participant-limit';
    message.setAttribute('role', 'alert');
    message.hidden = true;
    wrapper.after(message);
  }
  const quantity = Number(input.value);
  const tooMany = quantity > 2;
  const invalid = !Number.isInteger(quantity) || quantity < 1 || tooMany;
  const text = tooMany
    ? 'Si vous souhaitez procéder à une réservation pour plus de 2 personnes merci de nous appeler directement pour être accompagné par un de nos conseillers.'
    : 'Veuillez sélectionner 1 ou 2 adultes pour réserver en ligne.';
  if (message.textContent !== text) message.textContent = text;
  message.hidden = !invalid;
  details.classList.toggle('mc-participants-blocked', invalid);
  input.setCustomValidity(invalid ? text : '');
  if (invalid) input.setAttribute('aria-invalid', 'true');
  else input.removeAttribute('aria-invalid');
  const describedBy = new Set((input.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean));
  describedBy.add(message.id);
  input.setAttribute('aria-describedby', [...describedBy].join(' '));
}

function guardParticipantLimit(event) {
  const details = event.target.closest('.product-details');
  if (!details) return;
  if (event.type === 'click' && !event.target.closest('button[name="add"], .shopify-payment-button')) return;
  const input = details.querySelector('.quantity-selector-wrapper input[type="number"]');
  if (!input) return;
  syncQuantitySelection();
  if (!details.classList.contains('mc-participants-blocked')) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  input.focus({ preventScroll: true });
  details.querySelector('.mc-participant-limit')?.scrollIntoView({ block: 'nearest' });
}
document.addEventListener('click', guardParticipantLimit, true);
document.addEventListener('submit', guardParticipantLimit, true);

syncGloboDateSelection();
syncQuantitySelection();

document.addEventListener('change', (event) => {
  if (event.target.matches('.product-details .gpo-swatches.image-swatches.gpo-ov-item input[type="radio"]')) {
    syncGloboDateSelection();
  }
});

const productDetails = document.querySelector('.product-details');
if (productDetails) {
  new MutationObserver(() => {
    syncGloboDateSelection();
    syncQuantitySelection();
  }).observe(productDetails, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['value'],
  });
}

function highlightCalendarWeekends() {
  document.querySelectorAll('.flatpickr-day').forEach((day) => {
    const date = day.dateObj;
    if (!(date instanceof Date) || Number.isNaN(date.getTime())) return;

    const dayOfWeek = date.getDay();
    day.classList.toggle('mc-calendar-weekend', dayOfWeek === 0 || dayOfWeek === 6);
  });
}

highlightCalendarWeekends();
new MutationObserver(highlightCalendarWeekends).observe(document.body, {
  childList: true,
  subtree: true,
});

// Let a tall booking column move up naturally before pinning its bottom.
(() => {
  const column = document.querySelector('.mc-right-col');
  if (!column) return;
  const header = document.querySelector('#header-component');
  let frame;
  function update() {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => {
      const headerOffset = header?.dataset.stickyState === 'active' ? header.getBoundingClientRect().height : 0;
      const top = Math.min(headerOffset + 16, window.innerHeight - column.getBoundingClientRect().height - 16);
      column.style.setProperty('--mc-booking-sticky-top', `${top}px`);
    });
  }
  const observer = new ResizeObserver(update);
  observer.observe(column);
  if (header) {
    observer.observe(header);
    new MutationObserver(update).observe(header, { attributes: true, attributeFilter: ['data-sticky-state'] });
  }
  window.addEventListener('resize', update, { passive: true });
  update();
})();
